import React, { useEffect, useRef, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Layout from '../common/Layout';

const AddSections = () => {

    const { quizId, id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)

    const navigate = useNavigate()

    const [acitveCourses, setActiveCourses] = useState([])

    useEffect(() => {
        const loadData = async () => {
            await Promise.all([ getActiveCourses() ]);
            if (isEdit) {
                getQuizSections();
            }
        };
        loadData();
    }, []);

    const schema = yup.object({
        sectionId: yup.string().optional().nullable(), 
        courseId: yup.string().required("Please Select Course"), 
        sectionName: yup.string().required("Quiz Name is required"),
        sectionDescription: yup.string().required("Description is required"),
        courseThreshold:yup.number().transform((value, originalValue) => (originalValue === "" || isNaN(originalValue)) ? null : value).nullable().required("Course Thres hold is required"),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            sectionId: null,
            courseId: '',
            sectionName: '',
            sectionDescription: '',
            courseThreshold: '',
            isActive: false,
        })
    }

    const getQuizSections = () => {
        ApiHelper.get(`${API_ENDPOINTS.QUIZ_SECTION}/edit/${id}`).then((res) => {
            console.log('res:', res);
            if (res.status === 200) {
                reset({
                    sectionId: res.data.data.sectionId,
                    sectionName: res.data.data.sectionName,
                    sectionDescription: res.data.data.sectionDescription,
                    courseThreshold: res.data.data.courseThreshold,
                    courseId: res.data.data.courseId,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };
    
    const getActiveCourses = async () => {
        // console.log('id:', id);
        await ApiHelper.get(`${API_ENDPOINTS.COURSES}?active=true`).then((res) => {
            console.log('res:', res);
            if (res.status === 200) {
                setActiveCourses(res.data.data)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const onSubmit = (data) => {
        data.quizId = quizId
        data.displayOrder = 0
        if (data.sectionId) {
            update(data, data.sectionId)
        } else {
            add(data)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.QUIZ_SECTION}/${quizId}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate(-1)
                }, 1000)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data, sectionId) => {
        ApiHelper.put(`${API_ENDPOINTS.QUIZ_SECTION}/edit/${sectionId}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate(-1)
                }, 1000)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

  return (
    <>
        <Toast ref={toast} />
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2">
                            <span class="d-flex text-muted fw-light"> 
                                <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate(`/quiz/${quizId}/section`)}> Manage Sections </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                            </span>
                        </h4>
                        <Link to={-1} class="btn btn-secondary">⬅ Go Back</Link>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <div>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Name</label>
                                                    <input type="text" name="sectionName" class="form-control" {...register("sectionName")} />
                                                    <small className="text-danger">{errors.sectionName?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Description</label>
                                                    <input type="text" name="sectionDescription" class="form-control" {...register("sectionDescription")} />
                                                    <small className="text-danger">{errors.sectionDescription?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Course Threshold</label>
                                                    <input type="number" name="courseThreshold" class="form-control" {...register("courseThreshold")} />
                                                    <small className="text-danger">{errors.courseThreshold?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Course</label>
                                                    <select id="mySelect" name="courseId" class="form-select" {...register("courseId")} >
                                                        <option value="">Select Course</option>
                                                        {acitveCourses.map((item) => (
                                                            <option value={item.courseId}>{item.courseName}</option>
                                                        ))}
                                                    </select>
                                                    <small className="text-danger"> {errors.courseId?.message} </small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Status</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                    </div>
                                                </div>
                                                <input type='hidden' {...register("sectionId")}/>
                                            </div>
                                            <div class="mt-4 mb-3">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </>
  )
}

export default AddSections
